import { type Inspiration } from '$/services/usecases/inspirations/mapper/inspiration.schema';
import { type MaterialType } from '$/services/usecases/materials/mapper/materials';

const facadeCategories = [
  'one_family_house',
  'two_family_house',
  'apartment_building',
  'town_house',
  'half_timbered_house',
  'historical_facade',
];

export const config = {
  materials: {
    homepagePreviewIds: [
      // Lavendel 105
      'Y29sb3JfdGludF9fX3Byb2RfKGNhcGFyb2wpX19fY29sXygzZC1zeXN0ZW0tcGx1cylfX18yMDEtM19fX2xhdmVuZGVsIDEwNV9fX19fX2FvX19fZzFfX18',
      // M-Plus Pro Vlies 2027 — 3001-024907
      'd2FsbF90ZXh0dXJlX19fcHJvZF8oTVBsdXMpX19fY29sXyhQcm9fVmxpZXNfMjAyNylfX19fX18zMDAxXzAyNDkwN19fX19fX2FvX19fZzFfX18',
      // M-Plus Avanti 2026 — 2054-000951
      'Zmxvb3JfdGV4dHVyZV9fX3Byb2RfKE1wbHVzKV9fX2NvbF8oQXZhbnRpXzIwMjYpX19fX19fRDIwNTQtMDAwOTUxX1JCMjA1NC0wMDA5NzZfX19fX19hb19fX2cxX19f',
      // Alligator Oldinger — Meldorfer Dithmarschen
      'ZmFjYWRlX3RleHR1cmVfX19wcm9kXyhBbGxpZ2F0b3IpX19fY29sXyhPbGRpbmdlcilfX19fX19tZWxkb3JmZXItZGl0aG1hcnNjaGVuX19fX19fYW9fX19nMV9fXw',
    ],
  },
  filter: {
    colors: new Map([
      ['white', '#FFFFFF'],
      ['black', '#000000'],
      ['yellow', '#FFE600'],
      ['orange', '#FF9900'],
      ['red', '#FF0000'],
      ['pink', '#FF00F5'],
      ['purple', '#8F00FF'],
      ['blue', '#0085FF'],
      ['green', '#00CC52'],
      ['beige', '#C7BEB3'],
      ['brown', '#804500'],
      ['grey', '#808080'],
    ]),
  },
  inspirations: {
    getForMaterialModal: (type: MaterialType, inspirations: Inspiration[]) =>
      inspirations
        .filter(
          ({ category, name }) =>
            !name.includes('DesignGuide') &&
            (type === 'facade_texture'
              ? facadeCategories.includes(category)
              : !facadeCategories.includes(category)),
        )
        .slice(0, 3)
        .map(({ id, thumbnail }, index) => ({
          id,
          thumbnail,
          label: `Inspiration ${index + 1}`,
        })),
  },
  editor: {
    images: {
      maxSizeMB: 15,
      allowedFormats: ['jpg', 'jpeg', 'png'],
    },
    maxViews: 3,
  },
};
